import { render, staticRenderFns } from "./ProductVideoCreateEdit.vue?vue&type=template&id=23780d03"
import script from "./ProductVideoCreateEdit.vue?vue&type=script&lang=js"
export * from "./ProductVideoCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports